<template>
  <div>
    <!-- <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>

          <CRow>
            <CCol sm="3">
              <div class="form-group">
                <label for="voucher_group">Voucher Group</label>
                <model-select
                  class="form-control"
                  id="voucher_group"
                  :options="voucherGroupList"
                  v-model="$v.voucherForm.voucher_group.$model"
                  :isError="$v.voucherForm.voucher_group.$invalid"
                  :isRequired="true"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.voucherForm.voucher_group.$invalid"
                  class="invalid-feedback-custom"
                >
                  Voucher group should be filled.
                </div>
              </div>
            </CCol>
          </CRow>
      
          <CRow>
            <CCol sm="3">
              <CInput
                label="Voucher Name"
                invalid-feedback="Voucher name should be filled"
                required
                v-model="$v.voucherForm.name.$model"
                :is-valid="!$v.voucherForm.name.$invalid"
              />
            </CCol>

            <CCol sm="3">
              <CInput
                label="Abbreviation"
                invalid-feedback="Abbreviation should be filled"
                required
                v-model="$v.voucherForm.abbreviation.$model"
                :is-valid="!$v.voucherForm.abbreviation.$invalid"
              />
            </CCol>

            <CCol sm="6">
              <div class="form-group">
                <label for="payment_method">Payment Method</label>
                <multi-select
                  :options="paymentList"
                  :selected-options="paymentItem"
                  @select="onSelect"
                  v-model="$v.voucherForm.payment.$model"
                  :isError="$v.voucherForm.payment.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></multi-select>
                <div
                  v-if="$v.voucherForm.payment.$invalid"
                  class="invalid-feedback-custom"
                >
                  Payment method should be filled.
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="3">
              <div class="form-group">
                <label for="start_date">Tanggal mulai Berlaku</label>
                <vc-date-picker
                  id="start_date"
                  :input-props="{
                    class: !$v.voucherForm.start_date.$invalid
                      ? 'form-control is-valid'
                      : 'form-control is-invalid',
                    placeholder: 'Tanggal Mulai Berlaku',
                  }"
                  :popover="{ placement: 'top-start' }"
                  :state="!$v.voucherForm.start_date.$invalid"
                  v-model="$v.voucherForm.start_date.$model"
                  :is-required="true"
                ></vc-date-picker>
                <div
                  v-if="$v.voucherForm.start_date.$invalid"
                  class="invalid-feedback-custom"
                >
                  Date should be filled.
                </div>
              </div>
            </CCol>

            <CCol sm="3">
              <div class="form-group">
                <label for="end_date">Tanggal akhir Berlaku</label>
                <vc-date-picker
                  id="end_date"
                  :input-props="{
                    class: !$v.voucherForm.end_date.$invalid
                      ? 'form-control is-valid'
                      : 'form-control is-invalid',
                    placeholder: 'Tanggal Akhir Berlaku',
                  }"
                  :popover="{ placement: 'top-start' }"
                  :state="!$v.voucherForm.end_date.$invalid"
                  v-model="$v.voucherForm.end_date.$model"
                  :is-required="true"
                ></vc-date-picker>
                <div
                  v-if="$v.voucherForm.end_date.$invalid"
                  class="invalid-feedback-custom"
                >
                  Date should be filled.
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="3">
              <div class="form-group">
                <label for="voucher_type">Tipe Voucher</label>
                <model-select
                  class="form-control"
                  id="voucher_type"
                  :options="voucherTypeList"
                  v-model="$v.voucherForm.voucher_type.$model"
                  :isError="$v.voucherForm.voucher_type.$invalid"
                  @input="filterVoucherType"
                  :isRequired="true"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.voucherForm.voucher_type.$invalid"
                  class="invalid-feedback-custom"
                >
                  Voucher Type should be filled.
                </div>
              </div>
            </CCol>

            <CCol sm="3" v-if="voucherForm.voucher_type == 1">
              <CInput
                type="number"
                label="Price Cut (dalam Rupiah)"
                invalid-feedback="Price Cut Should Be Filled"
                v-model="$v.voucherForm.price.$model"
                :is-valid="!$v.voucherForm.price.$invalid"
              />
            </CCol>

            <CCol sm="3" v-if="voucherForm.voucher_type == 2">
              <CInput
                type="number"
                label="Percentage Cut (dalam Persen)"
                invalid-feedback="Percentage Cut Should Be Filled"
                v-model="$v.voucherForm.percentage.$model"
                :is-valid="!$v.voucherForm.percentage.$invalid"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="3">
              <CInput
                type="number"
                label="Maximal Price"
                invalid-feedback="Maximal Price Should Be Filled"
                v-model="$v.voucherForm.max_price.$model"
                :is-valid="!$v.voucherForm.max_price.$invalid"
              />
            </CCol>
            <CCol sm="3">
              <CInput
                type="number"
                label="Minimum Transaction"
                invalid-feedback="Minimum Transaction Should Be Filled"
                v-model="$v.voucherForm.min_transaction.$model"
                :is-valid="!$v.voucherForm.min_transaction.$invalid"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="6">
              <label for="desription">Description</label>
              <quill-editor
                style="height: 150px; margin-bottom: 70px"
                :content="content.description"
                :options="editorOption"
                v-model="$v.voucherForm.description.$model"
                :isError="$v.voucherForm.description.$invalid"
                @change="onEditorChange($event, 'description')"
              >
              </quill-editor>
              <div
                v-if="$v.voucherForm.description.$invalid"
                class="invalid-feedback-custom"
              >
                Description harus di isi.
              </div>
            </CCol>
            <CCol sm="6">
              <label for="tnc">Syarat Dan Ketentuan</label>
              <quill-editor
                style="height: 150px; margin-bottom: 70px"
                :content="content.tnc"
                :options="editorOption"
                v-model="$v.voucherForm.tnc.$model"
                :isError="$v.voucherForm.tnc.$invalid"
                @change="onEditorChange($event, 'tnc')"
              >
              </quill-editor>
              <div
                v-if="$v.voucherForm.tnc.$invalid"
                class="invalid-feedback-custom"
              >
                Syarat dan ketentuan harus di isi.
              </div>
            </CCol>
          </CRow>
        </CForm>
        <br/>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.voucherForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "../../templates/Loading";
import custom_validation from "@/templates/_customValidation.js";
import Vuelidate from "vuelidate";
import * as moment from "moment";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import { MultiSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import _ from "lodash";

export default {
  name: "Voucher",
  components: { Loading, quillEditor, JqxGrid, TableButton, MultiSelect },
  data() {
    return {
      title: "Voucher",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "voucher_code", type: "string" },
          { name: "name", type: "string" },
          { name: "abbreviation", type: "string" },
          { name: "start_date", type: "date" },
          { name: "end_date", type: "date" },
          { name: "price", type: "number" },
          { name: "percentage", type: "float" },
          { name: "max_price", type: "number" },
          { name: "payment_label", type: "string" },
          { name: "status", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "voucher_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode Voucher",
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Voucher",
          hidden: true,
        },
        {
          datafield: "abbreviation",
          columntype: "textbox",
          filtertype: "textbox",
          text: "SKU",
          width: 100,
        },
        {
          datafield: "start_date",
          columntype: "datetimeinput",
          filtertype: "date",
          text: "Tanggal Mulai",
          cellsformat: "d",
          cellsalign: "right",
          align: "right",
        },
        {
          datafield: "end_date",
          columntype: "datetimeinput",
          filtertype: "date",
          text: "Tanggal Berakhir",
          cellsformat: "d",
          cellsalign: "right",
          align: "right",
        },

        {
          datafield: "price",
          columntype: "numberinput",
          filtertype: "textbox",
          text: "Potongan Harga",
          cellsformat: "c2",
          cellsalign: "right",
          align: "right",
        },
        {
          datafield: "percentage",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Persentase %",
          cellsalign: "center",
          align: "center",
          hidden: true,
        },
        {
          datafield: "max_price",
          columntype: "numberinput",
          filtertype: "textbox",
          text: "Harga Maksimum",
          cellsformat: "c2",
          cellsalign: "right",
          hidden: true,
        },
        {
          datafield: "payment_label",
          columntype: "textbox",
          filtertype: "textbox",
          cellsalign: "center",
          align: "center",
          text: "Metode Pembayaran",
        },
        {
          datafield: "status",
          columntype: "textbox",
          filtertype: "textbox",
          cellsalign: "center",
          align: "center",
          text: "Status",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      listBoxSource: [
        {
          label: "Pot. Harga",
          value: "price",
          checked: true,
        },
        {
          label: "Diskon %",
          value: "percentage",
          checked: false,
        },
        {
          label: "Harga Maksimum",
          value: "max_price",
          checked: false,
        },
      ],

      paymentList: [],
      paymentItem: [],
      voucherGroupList: [],

      voucherForm: tableInterfaces.voucher,
      items: null,
      voucherTypeList: [
        { value: "1", text: "Diskon Harga" },
        { value: "2", text: "Diskon Persen" },
      ],
      content: {
        description: "",
        tnc: "",
      },
      editorOption: {},
      selectedVoucherType: "",
      // parentCategoryList: [],
      // categoryList: [],
      // groupList: [],
      // agentList: [],
      // tempParentCategoryList: [],
      // tempCategoryList: [],
      isLoading: false,
      isEdit: false,
      addButton: false,
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations() {
    if (this.voucherForm.voucher_type == 1) {
      return custom_validation.addVoucherFormCustom.price_cut;
    } else {
      return custom_validation.addVoucherFormCustom.percentage_cut;
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getVoucherListing();
      this.getPaymentList();
      this.getVoucherGroupList();
    },
    onSelect(paymentItem, lastSelectItem) {
      this.paymentItem = paymentItem;
      this.voucherForm.payment = paymentItem;
      // console.log(this.paymentItem)
    },
    filterVoucherType: function (event) {
      if (this.voucherForm.voucher_type == 1) {
        this.voucherForm.percentage = null;
      } else {
        this.voucherForm.price = null;
      }
    },
    onEditorChange({ quill, html, text }, param) {
      this.content[param] = html;
      this.voucherForm[param] = html;
    },
    getVoucherListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/voucher/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            // console.log(response.data.data)
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPaymentList: function () {
      this.axios
        .get("console/dropdown/payment_method_list")
        .then((response) => {
          this.paymentList = response.data.data;
        });
    },
    getVoucherGroupList: function () {
      this.axios.get("console/dropdown/voucher-group-list").then((response) => {
        this.voucherGroupList = response.data.data;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.voucherForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.voucher) {
        tableInterfaces.voucher[i] = null;
      }
      this.voucherForm = tableInterfaces.voucher;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this voucher ?")) {
        if (
          (this.voucherForm.voucher_type == 1 &&
            this.voucherForm.price >= 0 &&
            this.voucherForm.price <= 1000000000) ||
          (this.voucherForm.voucher_type == 2 &&
            this.voucherForm.percentage >= 0 &&
            this.voucherForm.percentage <= 100)
        ) {
          let path = this.$route.path.split("/");
          this.isLoading = true;
          this.axios
            .post("console/voucher/add", this.voucherForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
                this.$router.push({
                  path: path[2] + "/detail/" + response.data.id,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.init();
            });
        } else {
          alert(
            "Percentage dan Price harus Angka\n\nPRICE CUT MAX 1.000.000.000\nPERCENTAGE CUT MAX 100"
          );
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
